"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WILL_START = exports.STOPPING = exports.STARTING = exports.IDLE = exports.DICTATING = void 0;
var IDLE = 0;
exports.IDLE = IDLE;
var WILL_START = 1;
exports.WILL_START = WILL_START;
var STARTING = 2;
exports.STARTING = STARTING;
var DICTATING = 3;
exports.DICTATING = DICTATING;
var STOPPING = 4;
exports.STOPPING = STOPPING;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJJRExFIiwiV0lMTF9TVEFSVCIsIlNUQVJUSU5HIiwiRElDVEFUSU5HIiwiU1RPUFBJTkciXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL0RpY3RhdGVTdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBJRExFID0gMDtcbmNvbnN0IFdJTExfU1RBUlQgPSAxO1xuY29uc3QgU1RBUlRJTkcgPSAyO1xuY29uc3QgRElDVEFUSU5HID0gMztcbmNvbnN0IFNUT1BQSU5HID0gNDtcblxuZXhwb3J0IHsgRElDVEFUSU5HLCBJRExFLCBTVEFSVElORywgU1RPUFBJTkcsIFdJTExfU1RBUlQgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBTUEsSUFBSSxHQUFHLENBQWI7O0FBQ0EsSUFBTUMsVUFBVSxHQUFHLENBQW5COztBQUNBLElBQU1DLFFBQVEsR0FBRyxDQUFqQjs7QUFDQSxJQUFNQyxTQUFTLEdBQUcsQ0FBbEI7O0FBQ0EsSUFBTUMsUUFBUSxHQUFHLENBQWpCIn0=